import type { BucketSummary } from '../../hooks/home/useHomeData'
import icons from '../../config/icons.config'
import AppIcon from '../icons/AppIcon'
import MaskedIcon from '../icons/MaskedIcon'
import Card from '../primitives/Card'
import ProgressBar from '../primitives/ProgressBar'
import styles from './BucketGrid.module.css'

interface BucketGridProps {
  buckets: BucketSummary[]
}

function bucketIconColor(variant: BucketSummary['variant']) {
  if (variant === 'done') return 'var(--green)'
  if (variant === 'warn') return 'var(--muted-2)'
  return 'var(--blue)'
}

export default function BucketGrid({ buckets }: BucketGridProps) {
  return (
    <div className={styles.grid}>
      {buckets.map((bucket) => (
        <Card
          key={bucket.bucketId}
          variant={bucket.variant === 'done' ? 'done' : 'default'}
          className={styles.card}
          data-testid="bucket-tile"
        >
          <div className={styles.top}>
            <MaskedIcon
              src={bucket.icon}
              size={52}
              color={bucketIconColor(bucket.variant)}
              className={styles.icon}
            />
            {bucket.variant === 'done' && (
              <AppIcon icon={icons.checkCircle} size={17} className={styles.flag} />
            )}
          </div>
          <div className={styles.name}>{bucket.label}</div>
          <div className={styles.amount}>
            <span className={styles.value}>{bucket.value}</span>
            <span className={styles.goal}>/ {bucket.goal}</span>
          </div>
          <div className={styles.bar}>
            <ProgressBar
              percent={bucket.percent}
              variant={bucket.variant === 'done' ? 'done' : 'default'}
            />
          </div>
        </Card>
      ))}
    </div>
  )
}
